<template>
	<div class="clients">
		<breadcrumb :items="[{ text: 'Clientes', active: true }]" />
		<router-link class="btn btn-primary btn-add" :to="{name:'cadastrar-usuario', params: { role: 'client' } }"><i class="fa fa-plus"></i> Cadastrar cliente</router-link>
		<input v-model="filters.search" class="form-control mb-2" placeholder="Buscar...">
		<b-alert variant="danger" show v-if="error">{{error}}</b-alert>
		<loading :loading="!users && !error" msg="Carregando lista de usuarios" />
		<no-item :list="users" />
		<div v-if="users && users.length">
			<b-table stacked="lg" :fields="table_fields" :items="users" :sort-by="'name'" :filter="filters.search">
				<template slot="name" slot-scope="data">
					<router-link :to="'/usuario/'+ data.item._id">
						{{data.item.name}}
						<small><br>{{data.item.email}}</small>
					</router-link>
				</template>
				<template slot="roles" slot-scope="data">
					{{data.value | roles}}
					<small v-if="data.value && data.value[0] == 'manager' && data.item.organization"><br>{{data.item.organization.name}}</small>
					<small v-if="data.value && data.value[0] == 'supplier' && data.item.supplier"><br>{{data.item.supplier.name}}</small>
				</template>
				<template slot="actions" slot-scope="data">
					<div class="btn-group btn-group-sm">
						<router-link class="btn btn-primary" :to="'/editar-usuario/'+ data.item._id">
							<i class="fa fa-pencil"></i>
						</router-link>
						<button v-if="isSupplier" class="btn btn-secondary" @click="remove(data.item._id)"> <i class="fa fa-close"></i> </button>
					</div>
				</template>
			</b-table>
		</div>
	</div>
</template>
<script>
import axios from 'axios'
import Loading from '@/components/Loading'
import NoItem from '@/components/NoItem'

export default {

	name: 'Users',

	data () {
		return {

			filters: { search: null },
			table_fields: [
				{ key: 'name', label: 'Nome', sortable: true },
				{ key: 'roles', label: 'Perfis', sortable: true },
				{ key: 'actions', label: 'Ações', 'class': 'td-actions' },
			],
			users: null
		}
	},
	created () {
		this.list()
	},
	methods: {
		list () {
			axios.get('users?role=client', {
				params: {
					populate: 'organization supplier'
				}
			}).then(response => {
				this.users = response.data
			}).catch(this.showError)
		},
		remove (id) {
			if (confirm("Tem certeza que deseja excluír?")) {
				axios.delete('users/' + id).then(() => {
					this.list()
				}).catch(this.showError)
			}
		}
	},
	components: {
		Loading,
		NoItem,
	}

};
</script>
